import { themedSvgDataUrls } from "../../shared/themedSvg";
import type { ColorScheme } from "./colorScheme";
export type ThemedSvgSources = Record<ColorScheme, string>;

const sources = new Map<string, ThemedSvgSources | null>();

export function themedSvgSources(src: string): ThemedSvgSources | null {
  if (src.endsWith(".light.svg")) {
    return { light: src, dark: src.replace(/\.light\.svg$/, ".dark.svg") };
  }
  if (!src.startsWith("data:image/svg+xml")) return null;
  const cached = sources.get(src);
  if (cached !== undefined) return cached;

  const comma = src.indexOf(",");
  const content = src.slice(comma + 1);
  const svg = src.slice(0, comma).endsWith(";base64")
    ? new TextDecoder().decode(
        Uint8Array.from(atob(content), (character) => character.charCodeAt(0))
      )
    : decodeURIComponent(content.replace(/%(?![0-9a-f]{2})/gi, "%25"));

  const result = themedSvgDataUrls(svg);
  sources.set(src, result);
  return result;
}
